import { datadogRum } from '@datadog/browser-rum-slim'

import { parseAttributes } from '.././actions/static'

const startTimingEventName = 'dd_timing_event_start'

const eventStartTimings: Map<string, number> = new Map()

const handleStartEvent = (payload: string): void => {
  const attributes = parseAttributes(payload)
  const attribute = attributes.find(({ name }) => name === startTimingEventName)

  if (attribute) {
    eventStartTimings.set(attribute.value, +new Date())
  }
}

const handleStopEvent = (eventName: string): void => {
  if (eventStartTimings.has(eventName)) {
    const eventStartTiming = eventStartTimings.get(eventName)
    const eventFinishTiming = +new Date()
    const timing = eventFinishTiming - eventStartTiming
    datadogRum.addTiming(eventName, timing)
  }
}

export {
  handleStartEvent,
  handleStopEvent
}
